import { render, staticRenderFns } from "./DetailsModal.vue?vue&type=template&id=78f152f2&"
import script from "./DetailsModal.vue?vue&type=script&lang=ts&"
export * from "./DetailsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports